module.exports = __webpack_public_path__ + "static/media/manual.273855b3.md";